import { render, staticRenderFns } from "./MiniBarChart.vue?vue&type=template&id=35b4a11c&scoped=true&"
import script from "./MiniBarChart.vue?vue&type=script&lang=js&"
export * from "./MiniBarChart.vue?vue&type=script&lang=js&"
import style0 from "./MiniBarChart.vue?vue&type=style&index=0&id=35b4a11c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b4a11c",
  null
  
)

export default component.exports